<div
  class="tipo-de-obra-content titles"
  appDropdownToggle
  #dropdown="dropdownToggle"
  (click)="dropdown.toggle()"
>
  <div class="icon-text">
    <span class="icon-circle">
      <img
        class="img-icon"
        src="{{
          BASE_IMG_URL
        }}assets/filtro-lateral-busca/calendar.svg"
        alt=""
        width="22"
        height="22"
      />
    </span>

    <h2>TÉRMINO DA OBRA</h2>
  </div>
  <a
    class="btn tipo-de-obra-link"
    data-bs-toggle="collapse"
    role="button"
    aria-expanded="true"
    href="#btn_valor"
    aria-expanded="true"
    (click)="$event.stopPropagation(); dropdown.toggle()"
    (keydown.enter)="dropdown.toggle()"
    (keydown.space)="dropdown.toggle()"
  >
    <img
      class="img-icon"
      [ngClass]="{ 'girar-icon': dropdown.isOpen }"
      src="{{
        BASE_IMG_URL
      }}assets/filtro-lateral-busca/icone-seta-fechar.svg"
      alt=""
      width="18"
      height="18"
    />
  </a>
</div>

<div class="collapse show check-total" id="btn_valor" *ngIf="dropdown.isOpen">
  <div class="form-check data-obra">
    <div class="date">
      <label for="startDate">Data Início</label>
      <input
        id="startDate"
        type="date"
        class="custom-date-input"
        name="data-inicio"
        placeholder=""
        [(ngModel)]="dataInicio"
        (change)="onDataInicioChange($event)"
        [class.disabled]="disabled"
        [disabled]="disabled"
      />
    </div>

    <div class="date">
      <label for="endDate">Data Final</label>
      <input
        id="endDate"
        type="date"
        class="custom-date-input"
        name="data-final"
        placeholder=""
        [(ngModel)]="dataFim"
        (change)="onDataFimChange($event)"
        [class.disabled]="disabled"
        [disabled]="disabled"
      />
    </div>
  </div>
</div>
